import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { LocaleService } from '@sm360/widget-commons-core-services';

import './VehicleDisclaimersContent.scss';

function isDisclaimerValid(disclaimerValue) {
    return disclaimerValue && disclaimerValue.trim();
}

function disclaimerTemplateFromList(disclaimers) {
    return Object.values(disclaimers).map(
        (disclaimer) =>
            isDisclaimerValid(disclaimer) && (
                <span key={disclaimer}>
                    {disclaimer}
                    &nbsp;
                </span>
            )
    );
}

const VehicleDisclaimersContent = ({
    disclaimers,
    uniqueDisclaimer,
    disclaimersContentZone,
    genericDisclaimers,
    onOrderDisclaimer,
}) => {
    return (
        <div className="VehicleDisclaimersContent">
            {(uniqueDisclaimer || disclaimers) && (
                <div className="disclaimer tile-disclaimer">
                    <div className="disclaimer-star">*</div>
                    {uniqueDisclaimer || disclaimerTemplateFromList(disclaimers)}
                </div>
            )}
            <div className="disclaimer">
                {!isEmpty(genericDisclaimers) && (
                    <div className="disclaimer">{disclaimerTemplateFromList(genericDisclaimers)}</div>
                )}
                {isDisclaimerValid(disclaimersContentZone) && (
                    <div className="disclaimer">
                        <span>{disclaimersContentZone}</span>
                    </div>
                )}
                {onOrderDisclaimer && (
                    <div className="disclaimer">
                        <span>{LocaleService.t('VEHICLE_TILE.DISCLAIMER_ON_ORDER')}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

VehicleDisclaimersContent.defaultProps = {
    disclaimers: null,
    disclaimersContentZone: '',
    genericDisclaimers: [],
    onOrderDisclaimer: false,
    uniqueDisclaimer: '',
};

VehicleDisclaimersContent.propTypes = {
    /** Disclaimers from the Showroom API */
    disclaimers: PropTypes.shape({
        vehicleDescription: PropTypes.string,
        sellingPrice: PropTypes.string,
        priceInclusions: PropTypes.string,
        priceExclusions: PropTypes.string,
        termAndApr: PropTypes.string,
        paymentAndCash: PropTypes.string,
        obligationAndInterest: PropTypes.string,
        creditApproval: PropTypes.string,
    }),
    uniqueDisclaimer: PropTypes.string, // V2.5
    genericDisclaimers: PropTypes.arrayOf(PropTypes.string),
    disclaimersContentZone: PropTypes.string,
    onOrderDisclaimer: PropTypes.bool,
};

VehicleDisclaimersContent.displayName = 'VehicleDisclaimersContent';

export default VehicleDisclaimersContent;
